import ResetIcon from './component'

export default ResetIcon
